import { Map } from 'mapbox-gl';

import { isProduction } from '@lib/environment/isProduction';
import {
  RUTILUS_PRODUCTION_DOMAIN,
  RUTILUS_STAGING_DOMAIN,
  TILES_PRODUCTION_DOMAIN,
  TILES_STAGING_DOMAIN,
} from '../constants/constants';
import { hasSource } from '../helpers/mapHelpers';
import { ORDERED_FISHBRAIN_LAYERS } from '../mapData/layers';
import { Domain, Source, SOURCE } from '../mapData/sources';
import { FishbrainLayer } from '../types/types';

type GetTiles = (tilesDomain: Domain, tilesPath: string) => string;
type AppendSource = ({
  source,
  map,
  isPremium,
}: {
  source: Source;
  map: Map;
  isPremium?: boolean;
}) => void;
type AppendSources = (map: Map, isPremium: boolean, fibLayers: FishbrainLayer[]) => void;
type RemoveSources = (map: Map, fibLayers: FishbrainLayer[]) => void;

const getTiles: GetTiles = (tilesDomain, tilesPath) => {
  switch (tilesDomain) {
    case Domain.RUTILUS:
      return `${isProduction() ? RUTILUS_PRODUCTION_DOMAIN : RUTILUS_STAGING_DOMAIN}${tilesPath}`;
    case Domain.TILES:
      return `${isProduction() ? TILES_PRODUCTION_DOMAIN : TILES_STAGING_DOMAIN}${tilesPath}`;
    default:
      // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
      throw new Error(`Unhandled domain: ${tilesDomain}`);
  }
};

const appendSource: AppendSource = ({ source, map, isPremium = false }) => {
  const canBeAppended = source.premiumOnly ? isPremium : true;
  if (canBeAppended && !hasSource(map, source.name)) {
    map.addSource(source.name, {
      type: source.type,
      minzoom: source.minzoom,
      maxzoom: source.maxzoom,
      tiles: [getTiles(source.tilesDomain, source.tilesPath)],
    });
  }
};

const appendSources: AppendSources = (map, isPremium, fibLayers) => {
  fibLayers.forEach(source => {
    appendSource({ source: SOURCE[source], map, isPremium });
  });
};

const removeSources: RemoveSources = (map, fibLayers) => {
  ORDERED_FISHBRAIN_LAYERS.forEach(layer => {
    if (!fibLayers.includes(layer.fishbrainLayer)) {
      if (hasSource(map, layer.mapboxLayer.sourceName)) {
        map.removeSource(layer.mapboxLayer.sourceName);
      }
    }
  });
};

export { appendSources, removeSources };
